<template>
  <div class="container">
    <div class="no-print">
      <el-button
        icon="el-icon-printer"
        type="primary"
        style="float: right;margin:20px 20px 0 0;"
        @click="print"
        >打印</el-button
      >
    </div>
    <div id="main">
        <div class="top">机动车驾驶员培训结业证书（正面）</div>
        <div class="content">
            <div class="title">机动车驾驶员培训结业证书</div>
            <div id="info">
                <div id="no">证件编号：{{data.StudentCode}}</div>
                <img :src="'/api' + set.DsSpecifySignatureUrl" id="icon" v-if="set.DsShowSignature">
                <img :src="'/api' + data.CertUrl" id="photo">
            </div>
            <div id="text">
                (姓名)
                <span class="line">_{{data.FullName}}_</span>(性别)
                <span class="line">_{{sexName}}_</span> ，于
                <span class="line">_{{s1}}_</span>年<span class="line">_{{s2}}_</span>月<span class="line">_{{s3}}_</span>日至
                <span v-if="data.GraduationTime">
                  <span class="line">_{{e1}}_</span>年<span class="line">_{{e2}}_</span>月<span class="line">_{{e3}}_</span>
                </span>
                <span v-else>
                  <span class="line">_____</span>年<span class="line">_____</span>月<span class="line">_____</span>
                </span>日参加<span class="line">_机动车驾驶员培训{{data.CarType}}_</span> 的培训。已经完成教学大纲规定的培训内容，经考核合格，准予结业。
            </div>
            <div id="footer">
                <div id="org">
                    培训机构：{{data.SchoolName}}
                </div>
                <div id="date" v-if="set.DsShowDate">
                    <span class="line">_{{e1}}_</span>年<span class="line">_{{e2}}_</span>月<span class="line">_{{e3}}_</span>日
                </div>
                <div id="date" v-else>
                    <span class="line">____</span>年<span class="line">____</span>月<span class="line">____</span>日
                </div>
                <div id="org2">广东省道路运输事务中心监制</div>
            </div>
        </div>
        <div class="top" style="margin-top:0.5rem;">机动车驾驶员培训结业证书（背面）</div>
        <div class="content" style="height: 450px;">
            <div id="box">
                <div id="tip">说明</div>
                <div>1.本证为机动车驾驶员培训合格的证明。</div>
                <div>2.本证只供本人使用，不能转借，涂改。</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "windup",
  data() {
    return {
      api: require("@/api/st/student").default,
      tempApi: require("@/api/sy/template").default,
      data: {
        CertType: "",
        CertNo: "",
        CertUrl: "",
        Country: "",
        CarType: "",
        Sex: 0,
        BirthDate: "",
        Mobile: null,
        FullName: "",
        Address: "",
        StudentCode: null,
        GraduationTime: "",
      },
      set: {},
      CertNo: [],
      StartDate: [],
      EndDate: [],
    };
  },
  computed: {
    sexName() {
      if (this.data.Sex == 1) {
        return "男";
      }
      if (this.data.Sex == 2) {
        return "女";
      }
      return "";
    },
    card() {
      let res = this.data.CertNo[0];
      return res;
    },
    s1() {
      if(this.data.SignTime) {
        var date = new Date(this.data.SignTime);
        return date.getFullYear();
      } else {
        return "";
      }
    },
    s2() {
      if(this.data.SignTime) {
        var date = new Date(this.data.SignTime);
        return date.getMonth() + 1;
      } else {
        return "";
      }
    },
    s3() {
      if(this.data.SignTime) {
        var date = new Date(this.data.SignTime);
        return date.getDate();
      } else {
        return "";
      }
    },
    e1() {
      if(this.data.GraduationTime) {
        var date = new Date(this.data.GraduationTime);
        return date.getFullYear();
      } else {
        return "__";
      }
    },
    e2() {
      if(this.data.GraduationTime) {
        var date = new Date(this.data.GraduationTime);
        return date.getMonth() + 1;
      } else {
        return "__";
      }
    },
    e3() {
      if(this.data.GraduationTime) {
        var date = new Date(this.data.GraduationTime);
        return date.getDate();
      } else {
        return "__";
      }
    },
    n1() {
      var date = new Date();
      return date.getFullYear();
    },
    n2() {
      var date = new Date();
      return date.getMonth() + 1;
    },
    n3() {
      var date = new Date();
      return date.getDate();
    },
  },
  mounted() {
    if (Number(this.$route.query.id)) {
      this.api.info(this.$route.query.id).then(res => {
        if(res.Code==0) {
          this.data = res.Data;
          this.StartDate = this.$commonJs.toDateString(res.Data.BirthDate).split("-");
          for (let i = 0; i < 18; i++) {
            let data = res.Data.CertNo[i] ? res.Data.CertNo[i] : "";
            this.CertNo.push(data);
          }
          this.tempApi.getInfoByDpIdTempType(res.Data.SchoolId,2).then(res2 => {
            if(res2.Code==0 && res2.Data !== null) {
              this.set = res2.Data;
            }
          })
        }
      });
    }
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@media print and (color) {
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

@page {
  size: A4;
  margin: 0;
}

@media print {
  .container {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}

// h1 {
//   margin: 0.3em;
//   font-size: 16pt;
// }
// /deep/ .image-slot {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   // width: 100pt;
//   height: 100pt;
//   font-size: 16px;
//   // font-weight: 550;
//   color: #c0c4cc;
//   // background: #f5f7fa;
// }
// .title {
//   text-align: center;
// }

// .container {
//   font-size: 14px;
//   // font-size: 12pt;
//   // font-family: SimSun, 宋体, serif;
//   color: black;
//   line-height: 2;
//   text-align: justify;
//   margin: 0 auto;
//   padding: 0;
//   width: 200mm;
//   height: 290mm;
// }

// .img {
// }

// .card {
//   margin: 0 auto;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   width: 160mm;
//   align-items: center;
//   border: 1px solid #000;
// }

// .just {
//   padding: 0pt 20pt 0;
//   line-height: 2;
//   h3 {
//     margin: 0 0 5pt;
//   }
//   .heading {
//     width: 100%;
//     display: inline-flex;
//     justify-content: space-between;
//     .No {
//       margin-top: 15pt;
//       label {
//         margin-right: 3pt;
//       }
//     }
//     div {
//       display: inline-block;
//     }
//   }
//   .content {
//     margin: 10pt 0;
//   }
//   .sign {
//     margin-bottom: 5pt;
//     width: 100%;
//     text-align: right;
//   }
// }

// .reverse {
//   padding: 100pt 60pt;
// }

// .table {
//   // width: 190mm;
//   // height: 340mm;
//   margin: 0 auto;
//   border-collapse: collapse;

//   td {
//     // padding: 5pt 20pt; //根据情况自己设置
//     // text-align: center;
//     border: 1px solid #888;
//     // white-space: nowrap; //不换行
//   }

//   span:focus-visible,
//   td:focus-visible {
//     outline: none;
//   }

//   th {
//     // padding: 0 5pt;
//     border: 1px solid #888;
//     text-align: center;
//     font-weight: normal;
//   }
// }

// input {
//   width: 40pt;
//   border: none;
//   outline: none;
//   text-align: center;
//   border-bottom: 1px solid #000;
// }
* {
  font-family: '宋体';
}
#main {
  width: 760px;
  margin: auto;
}
.top {
  text-align: center;
  font-size: 30px;
  font-family: '黑体';
  letter-spacing: 2px;
  line-height: 3rem;
  padding: 15px 0 5px;
}

.content {
  width: 680px;
  border: 2px solid #000;
  margin: auto;
  padding: 0 10px;
  box-sizing: border-box;
}

.content .title {
  text-align: center;
  font-size: 26px;
  font-family: '黑体';
  letter-spacing: 2px;
  line-height: 3rem;
}

.content #info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0 1rem;
}

.content #info #no {
  font-size: 22px;
}

.content #info #photo {
  height: 160px;
  width: 130px;
  border: 1px dashed #aaa;
}

#icon {
  position: absolute;
  right: 90px;
  height: 130px;
  width: 130px;
  top: 90px;
}

#text {
  margin-top: 2rem;
  text-indent: 2rem;
  font-size: 20px;
  letter-spacing: 2px;
  line-height: 1.8rem;
}

.line {
  text-decoration: underline;
}

#footer {
  margin: 24px 0 0;
  font-size: 20px;
  letter-spacing: 2px;
  line-height: 1.6rem;
}

#footer #org {
  text-align: right;
  padding-right: 2rem;
}

#footer #date {
  text-align: right;
  padding-right: 2rem;
}

#footer #date .line {
  padding: 0 0.2rem;
}

#footer #org2 {
  text-align: center;
  margin: 10px 0;
}

#box {
  text-align: center;
  font-size: 24px;
  line-height: 3rem;
  margin-top: 120px;
}

#box #tip {
  text-align: center;
  line-height: 4rem;
  font-weight: bold;
  letter-spacing: 20px;
}
</style>